export default __webpack_public_path__ + "static/media/sociocredz.6d78c428.svg";